﻿import { Position } from 'geojson';

export interface PolygonFlightIntersection {
    acid: string;
    origin: string;
    destination: string;
    status: string;
    departureTime: number | null;
    arrivalTime: number | null;
    entryTime: number | null;
}
export interface AdvisoryRoute {
    sequence: number;
    distance: number | null;
    route: string;
}
export interface RerouteAdvisory {
    advisoryNumber: string;
    type: string;
    category: string;
    action: string;
    status: string;
    method: string;
    conformantFlights: number;
    nonConformantFlights: number;
    affectedRoutes: number;
    reRouteName: string;
    routes: AdvisoryRoute[];
    get details(): string;
}

export interface AirportDelay {
    name: string;
    fullName: string;
    type: string;
    reason: string;
    start: Date | null;
    end: Date | null;
    position: Position;
    affectedFlights: number | undefined;
    get details(): string;
    get verboseDetails(): string;
}

export interface FlightConstrainedArea {
    name: string;
    type: string;
    reason: string;
    start: Date | null;
    end: Date | null;
    altitude: number | null;
    affectedFlights: number | undefined;
    shape: ShapeType;
    center: Position;
    radius: number | null;
    points: Position[];
    get details(): string;
}

export enum ShapeType {
    None = 0,
    Poly = 1,
    Line = 2,
    Circular = 3,
    Airport = 4,
    Sector = 5,
    BaseSector = 6
}

//API Response Types
export interface FcaPoint {
    lat: number;
    lon: number;
}

export interface FlightConstrainedAreaResponse {
    shape: number;
    condition: number;
    startTime: string | null;
    endTime: string | null;
    afpStartTime: string | null;
    afpEndTime: string | null;
    type: number;
    color: number;
    lookAheadTime: number;
    ceiling: number | null;
    floor: number | null;
    avgDelay: number | null;
    direction: number | null;
    speed: number | null;
    centerLatitude: number | null;
    centerLongitude: number | null;
    radius: number | null;
    fcApoints: FcaPoint[];
    nasName: string;
    label: string;
    detail: string;
    filter: string;
}

export interface RerouteRoute {
    bitmap: number;
}

export interface RerouteAdvisoryResponse {
    bitmap: number;
    advisoryNumber: string;
    advisoryCategory: number;
    advisoryAction: number;
    rerouteLastUpdate: string | null;
    rerouteCreated: string | null;
    rerouteStartTime: string | null;
    rerouteEndTime: string | null;
    lastFlightListUpdate: string | null;
    fcaName: string;
    fcaStartTime: string | null;
    fcaEndTime: string | null;
    rerouteName: string;
    detail: string;
    routes: RerouteRoute[];
    routeText: string[];
}

export interface AirportDelayResponse {
    type: number;
    airportID: string;
    airportName: string;
    airportLat: number;
    airportLon: number;
    createTime: string;
    updateTime: string;
    reason: string;
    startTime: string;
    stopTime: string;
    averageOrMinDelay: number;
    maxDelay: number;
    trend: number;
}

export interface GetConstraintsResponse {
    fcaLastupdte: Date; //not a typo, this is how the API returns it
    rerouteLastUpdate: Date;
    faaDelayLastUpdate: Date;
    fcas: FlightConstrainedAreaResponse[];
    reroutes: RerouteAdvisoryResponse[];
    delays: AirportDelayResponse[];
}

export enum AirportDelayType {
    None = 0,
    Arrival = 1,
    Departure = 2,
    Closure = 3,
    PartialClosure = 4,
    GroundStop = 5,
    GroundDelay = 6
}

export enum DelayTrend {
    Increasing = 0,
    Decreasing = 1
}
